define('models/Alert',[
    'util/ObservableModel'
], function (
    ObservableModel
) {
    'use strict';

    return ObservableModel.extend({
        defaults: {
            name: null,
            dimension: null,
            dimensionValue: null,
            dimensionName: null,
            metric: null,
            mediaType: null,
            numericRange: null,
            statistic: null,
            value: null,
            unread: false,
            startDate: null,
            endDate: null,
            notificationUsers: [],
            alertTypes: []
        }
    }, function () {
    });
});
